// 50 mock services — all end dates in June–November 2026 (upcoming 6 months from June 2026)
// Split: 18 ongoing document/welfare services + 32 time-bound recruitment/exam services

const MOCK_SERVICES = [

  // ── ONGOING DOCUMENT & WELFARE SERVICES (end Dec 31 2026) ────────────────────

  {
    id: 'svc-001',
    serviceCategory: 'Aadhaar Enrollment Services',
    subCategory: 'Aadhaar Card New Enrollment',
    state: 'All India',
    serviceName: 'Aadhaar Card New Enrolment 2026',
    serviceDescription: 'Fresh Aadhaar enrolment for individuals without an Aadhaar number. Biometric capture, photograph, and document submission at authorised CSC centre. Immediate acknowledgement slip issued.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '50',
    feeEWS: '50',
    feeOBC: '50',
    feeScSt: '50',
    cscCharge: 50,
    officialLink: 'https://uidai.gov.in',
    requiredDocuments: [
      'Passport Size Photographs (Colour, White Background)',
      'Ration Card',
      'Birth Certificate',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-002',
    serviceCategory: 'Aadhaar Update Services',
    subCategory: 'Aadhaar Address and Name Update',
    state: 'All India',
    serviceName: 'Aadhaar Update and Correction 2026',
    serviceDescription: 'Update name, address, date of birth, or mobile number in your existing Aadhaar record at an authorised CSC centre. Original supporting documents required.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '50',
    feeEWS: '50',
    feeOBC: '50',
    feeScSt: '50',
    cscCharge: 50,
    officialLink: 'https://uidai.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-003',
    serviceCategory: 'PAN Card Services',
    subCategory: 'PAN Card New Application',
    state: 'All India',
    serviceName: 'New PAN Card Application 2026 (NSDL/UTI)',
    serviceDescription: 'Apply for a fresh Permanent Account Number (PAN) card through the NSDL or UTI portal. Required for income tax filing, bank accounts, and financial transactions.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '107',
    feeEWS: '107',
    feeOBC: '107',
    feeScSt: '107',
    cscCharge: 80,
    officialLink: 'https://www.onlineservices.nsdl.com',
    requiredDocuments: [
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Birth Certificate',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-004',
    serviceCategory: 'Voter ID Services',
    subCategory: 'New Voter ID Registration',
    state: 'All India',
    serviceName: 'Voter ID Card New Registration 2026 (Form 6)',
    serviceDescription: 'New voter registration for first-time voters or persons who have recently moved. Apply online through the National Voters Service Portal. Aadhaar-linked registration available.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 30,
    officialLink: 'https://voters.eci.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Domicile Certificate',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-005',
    serviceCategory: 'Driving License Services',
    subCategory: 'New Driving License Application',
    state: 'All India',
    serviceName: 'Driving Licence Learner Licence Application 2026',
    serviceDescription: 'Apply for a Learner Driving Licence for two-wheelers and four-wheelers via the Parivahan portal. Includes theory test slot booking. CSC assists with form filling and fee payment.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '16',
    maxAge: '100',
    feeGeneral: '200',
    feeEWS: '200',
    feeOBC: '200',
    feeScSt: '200',
    cscCharge: 100,
    officialLink: 'https://parivahan.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      '10th Pass Certificate / Marksheet (DMC)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-006',
    serviceCategory: 'Passport Assistance',
    subCategory: 'Passport Application Form Filling',
    state: 'All India',
    serviceName: 'Fresh Passport Application Normal Scheme 2026',
    serviceDescription: 'Apply for a fresh passport through the Passport Seva portal. CSC assists with appointment booking, form filling, document checklist, and submission for police verification.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '1500',
    feeEWS: '1500',
    feeOBC: '1500',
    feeScSt: '1500',
    cscCharge: 200,
    officialLink: 'https://passportindia.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Birth Certificate',
      'Voter ID Card (EPIC)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-007',
    serviceCategory: 'Passport Assistance',
    subCategory: 'Passport Application Form Filling',
    state: 'All India',
    serviceName: 'Tatkal Passport Application Urgent Scheme 2026',
    serviceDescription: 'Apply for a Tatkal (urgent) passport when travel is imminent. Processed within 3 working days post police verification. CSC assists with all documentation.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '3500',
    feeEWS: '3500',
    feeOBC: '3500',
    feeScSt: '3500',
    cscCharge: 250,
    officialLink: 'https://passportindia.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Birth Certificate',
      'Voter ID Card (EPIC)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-008',
    serviceCategory: 'PM Kisan Services',
    subCategory: 'PM Kisan Samman Nidhi Registration',
    state: 'All India',
    serviceName: 'PM Kisan Samman Nidhi New Farmer Registration 2026',
    serviceDescription: 'New farmer registration under PM Kisan Samman Nidhi for annual income support of ₹6,000 in three equal instalments. CSC assists with Aadhaar seeding and land record verification.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 50,
    officialLink: 'https://pmkisan.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Khatauni / Khasra (Land Record)',
      'Bank Statement (3 / 6 Months)',
      'Cancelled Cheque / Bank Account Details',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-009',
    serviceCategory: 'Kisan Credit Card',
    subCategory: 'KCC Application and Facilitation',
    state: 'All India',
    serviceName: 'Kisan Credit Card Application 2026',
    serviceDescription: 'Kisan Credit Card for flexible short-term credit for farmers covering crop cultivation, post-harvest, and allied activities. CSC coordinates with participating banks for KCC issuance.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 50,
    officialLink: 'https://pmkisan.gov.in/KCC.aspx',
    requiredDocuments: [
      'Aadhaar Card',
      'Khatauni / Khasra (Land Record)',
      'Bank Statement (3 / 6 Months)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-010',
    serviceCategory: 'Health Insurance Services',
    subCategory: 'Ayushman Bharat Health Card Printing',
    state: 'All India',
    serviceName: 'Ayushman Bharat PM-JAY Golden Card 2026',
    serviceDescription: 'PM Jan Arogya Yojana provides ₹5 lakh health cover per family per year for secondary and tertiary hospitalisation. CSC assists with eligibility check, registration, and card generation.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '30',
    feeEWS: '30',
    feeOBC: '30',
    feeScSt: '30',
    cscCharge: 30,
    officialLink: 'https://pmjay.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Ration Card',
      'BPL (Below Poverty Line) Card',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-011',
    serviceCategory: 'PM Jeevan Jyoti Bima',
    subCategory: 'PMJJBY Life Insurance Enrollment',
    state: 'All India',
    serviceName: 'PM Jeevan Jyoti Bima Yojana Enrolment 2026',
    serviceDescription: 'Life insurance providing ₹2 lakh cover on death from any cause. Annual premium ₹436 auto-debited from savings account. Available for ages 18–50. CSC assists with bank-linked enrolment.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '50',
    feeGeneral: '436',
    feeEWS: '436',
    feeOBC: '436',
    feeScSt: '436',
    cscCharge: 0,
    officialLink: 'https://jansuraksha.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Bank Statement (3 / 6 Months)',
      'Cancelled Cheque / Bank Account Details',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-012',
    serviceCategory: 'Jan Dhan Account Opening',
    subCategory: 'PM Jan Dhan Yojana Account',
    state: 'All India',
    serviceName: 'Pradhan Mantri Jan Dhan Yojana Account Opening 2026',
    serviceDescription: 'Zero-balance savings bank account under PMJDY with RuPay debit card, ₹1 lakh accident cover, and ₹10,000 overdraft facility. CSC assists with assisted account opening.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '10',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 0,
    officialLink: 'https://pmjdy.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Ration Card',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-013',
    serviceCategory: 'MNREGA Services',
    subCategory: 'Job Card Application and Update',
    state: 'All India',
    serviceName: 'MGNREGA Job Card Application 2026',
    serviceDescription: 'Apply for MGNREGA job card guaranteeing 100 days of wage employment per year for rural households. CSC assists with household registration and Aadhaar linking.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 0,
    officialLink: 'https://nrega.nic.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Voter ID Card (EPIC)',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-014',
    serviceCategory: 'PM Ujjwala Yojana',
    subCategory: 'Free LPG Connection Application',
    state: 'All India',
    serviceName: 'PM Ujjwala Yojana 2.0 Free LPG Connection 2026',
    serviceDescription: 'Free LPG cooking gas connection for women from BPL households under PMUY 2.0. One cylinder, regulator, and installation provided free. CSC assists in registration and document submission.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 0,
    officialLink: 'https://pmuy.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Ration Card',
      'BPL (Below Poverty Line) Card',
      'Cancelled Cheque / Bank Account Details',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-015',
    serviceCategory: 'Disability Certificate Services',
    subCategory: 'Disability Certificate Application',
    state: 'All India',
    serviceName: 'UDID Unique Disability Identity Card 2026',
    serviceDescription: 'Unique Disability Identification card for persons with disabilities (PwD) containing complete disability details. Required for government scheme benefits, reservations, and concessions.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '0',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 0,
    officialLink: 'https://www.swavlambancard.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Disability Medical Certificate (Medical Board)',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-016',
    serviceCategory: 'Labour Registration',
    subCategory: 'e-Shram Portal Worker Registration',
    state: 'All India',
    serviceName: 'e-Shram Unorganised Worker Registration 2026',
    serviceDescription: 'Register on the e-Shram National Database of Unorganised Workers for access to government welfare schemes. Receive e-Shram card with ₹2 lakh accident insurance. CSC assisted.',
    qualifications: ['NA'],
    startDate: '2026-01-01',
    endDate: '2026-12-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '16',
    maxAge: '59',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 20,
    officialLink: 'https://eshram.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Bank Statement (3 / 6 Months)',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-01-01T10:00:00.000Z',
  },

  {
    id: 'svc-017',
    serviceCategory: 'Income Tax Filing',
    subCategory: 'Income Tax Return (ITR) Filing',
    state: 'All India',
    serviceName: 'Income Tax Return Filing ITR-1 Salaried 2026-27',
    serviceDescription: 'Assisted ITR-1 filing for salaried individuals for Assessment Year 2026-27. CSC VLE assists with Form 16, deductions computation, and online submission on the Income Tax portal.',
    qualifications: ['NA'],
    startDate: '2026-04-01',
    endDate: '2026-07-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '200',
    feeEWS: '200',
    feeOBC: '200',
    feeScSt: '200',
    cscCharge: 200,
    officialLink: 'https://incometax.gov.in',
    requiredDocuments: [
      'PAN Card',
      'Aadhaar Card',
      'Form 16 (TDS Certificate)',
      'Bank Statement (3 / 6 Months)',
    ],
    createdAt: '2026-04-01T10:00:00.000Z',
  },

  {
    id: 'svc-018',
    serviceCategory: 'Fasal Bima Services',
    subCategory: 'PM Fasal Bima Yojana Registration',
    state: 'All India',
    serviceName: 'PM Fasal Bima Yojana Crop Insurance Kharif 2026',
    serviceDescription: 'PMFBY provides financial support to farmers suffering crop loss due to natural calamities. Register before the Kharif season cutoff. CSC assists with khasra, Aadhaar, and bank details.',
    qualifications: ['NA'],
    startDate: '2026-04-01',
    endDate: '2026-07-31',
    admitCardDate: '',
    admitCardComingSoon: false,
    examDate: '',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '100',
    feeGeneral: '0',
    feeEWS: '0',
    feeOBC: '0',
    feeScSt: '0',
    cscCharge: 50,
    officialLink: 'https://pmfby.gov.in',
    requiredDocuments: [
      'Aadhaar Card',
      'Khatauni / Khasra (Land Record)',
      'Bank Statement (3 / 6 Months)',
      'Cancelled Cheque / Bank Account Details',
    ],
    createdAt: '2026-04-01T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — JUNE 2026 CLOSING ─────────────────────────

  {
    id: 'svc-019',
    serviceCategory: 'SSC MTS Recruitment',
    subCategory: 'Multi Tasking Staff Exam',
    state: 'All India',
    serviceName: 'SSC MTS Multi Tasking Staff Recruitment 2026',
    serviceDescription: 'Staff Selection Commission MTS and Havaldar recruitment 2026 for Group C non-gazetted posts in central government departments. Computer-based test in two tiers.',
    qualifications: ['10th Pass'],
    startDate: '2026-06-01',
    endDate: '2026-06-30',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '25',
    feeGeneral: '100',
    feeEWS: '0',
    feeOBC: '100',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://ssc.nic.in',
    requiredDocuments: [
      '10th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Caste Certificate – SC',
    ],
    createdAt: '2026-05-25T10:00:00.000Z',
  },

  {
    id: 'svc-020',
    serviceCategory: 'NEET UG Exam Services',
    subCategory: 'NEET Undergraduate Medical Entrance',
    state: 'All India',
    serviceName: 'NEET UG 2026 Medical Entrance Exam Application',
    serviceDescription: 'National Eligibility cum Entrance Test for undergraduate medical admissions (MBBS/BDS/BAMS/BHMS). Conducted by NTA. Single national exam for all medical colleges in India.',
    qualifications: ['12th Pass'],
    startDate: '2026-05-15',
    endDate: '2026-06-30',
    admitCardDate: '2026-08-10',
    admitCardComingSoon: false,
    examDate: '2026-09-14',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '17',
    maxAge: '25',
    feeGeneral: '1700',
    feeEWS: '1600',
    feeOBC: '1600',
    feeScSt: '1000',
    cscCharge: 100,
    officialLink: 'https://nta.ac.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-05-10T10:00:00.000Z',
  },

  {
    id: 'svc-021',
    serviceCategory: 'IBPS Clerk Recruitment',
    subCategory: 'Bank Clerical Cadre Exam',
    state: 'All India',
    serviceName: 'IBPS CRP Clerk XVII Recruitment 2026',
    serviceDescription: 'IBPS Common Recruitment Process for clerical cadre posts in participating public sector banks. Selection through online preliminary and mains examination followed by provisional allotment.',
    qualifications: ['Graduation'],
    startDate: '2026-06-03',
    endDate: '2026-06-28',
    admitCardDate: '2026-08-01',
    admitCardComingSoon: false,
    examDate: '2026-08-23',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '20',
    maxAge: '28',
    feeGeneral: '850',
    feeEWS: '175',
    feeOBC: '850',
    feeScSt: '175',
    cscCharge: 110,
    officialLink: 'https://ibps.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'EWS (Economically Weaker Section) Certificate',
    ],
    createdAt: '2026-05-25T10:00:00.000Z',
  },

  {
    id: 'svc-022',
    serviceCategory: 'State Police Constable',
    subCategory: 'State Police Constable Bharti',
    state: 'Uttar Pradesh',
    serviceName: 'UP Police Constable Recruitment 2026',
    serviceDescription: 'Uttar Pradesh Police Recruitment and Promotion Board constable vacancy 2026. Over 60,000 posts available across the state. Selection through written exam, physical test, and document verification.',
    qualifications: ['12th Pass'],
    startDate: '2026-06-01',
    endDate: '2026-06-30',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '22',
    feeGeneral: '400',
    feeEWS: '400',
    feeOBC: '400',
    feeScSt: '400',
    cscCharge: 100,
    officialLink: 'https://uppbpb.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-05-28T10:00:00.000Z',
  },

  {
    id: 'svc-023',
    serviceCategory: 'RRB ALP Recruitment',
    subCategory: 'Assistant Loco Pilot Exam',
    state: 'All India',
    serviceName: 'RRB ALP and Technician Recruitment 2026',
    serviceDescription: 'Railway Recruitment Board Assistant Loco Pilot and Technician posts 2026. CBT in two stages followed by aptitude test. Thousands of vacancies across all railway zones.',
    qualifications: ['10th Pass', '12th Pass'],
    startDate: '2026-05-20',
    endDate: '2026-06-30',
    admitCardDate: '2026-08-20',
    admitCardComingSoon: false,
    examDate: '2026-09-20',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '30',
    feeGeneral: '500',
    feeEWS: '250',
    feeOBC: '500',
    feeScSt: '250',
    cscCharge: 100,
    officialLink: 'https://indianrailways.gov.in',
    requiredDocuments: [
      'ITI National Trade Certificate (NTC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      '10th Pass Certificate / Marksheet (DMC)',
    ],
    createdAt: '2026-05-15T10:00:00.000Z',
  },

  {
    id: 'svc-024',
    serviceCategory: 'State PSC Services',
    subCategory: 'State Public Service Commission Exam',
    state: 'Haryana',
    serviceName: 'HSSC CGL Combined Graduate Level Recruitment 2026',
    serviceDescription: 'Haryana Staff Selection Commission CGL exam 2026 for Group B and C posts in various Haryana government departments. Written test followed by document verification.',
    qualifications: ['Graduation'],
    startDate: '2026-06-05',
    endDate: '2026-06-27',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '42',
    feeGeneral: '150',
    feeEWS: '35',
    feeOBC: '35',
    feeScSt: '35',
    cscCharge: 90,
    officialLink: 'https://hssc.gov.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
    ],
    createdAt: '2026-05-30T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — JULY 2026 CLOSING ─────────────────────────

  {
    id: 'svc-025',
    serviceCategory: 'State Sub Inspector Recruitment',
    subCategory: 'Police Sub Inspector Written Exam',
    state: 'Bihar',
    serviceName: 'Bihar Police Sub Inspector Recruitment 2026',
    serviceDescription: 'BPSSC Sub Inspector of Police recruitment 2026. Selection through preliminary written test, mains written test, and physical efficiency test. Applications via CSC centres.',
    qualifications: ['Graduation'],
    startDate: '2026-06-02',
    endDate: '2026-07-15',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '20',
    maxAge: '37',
    feeGeneral: '700',
    feeEWS: '350',
    feeOBC: '500',
    feeScSt: '350',
    cscCharge: 100,
    officialLink: 'https://bpssc.bih.nic.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-06-01T10:00:00.000Z',
  },

  {
    id: 'svc-026',
    serviceCategory: 'State Sub Inspector Recruitment',
    subCategory: 'Police Sub Inspector Written Exam',
    state: 'Rajasthan',
    serviceName: 'Rajasthan Police Sub Inspector Recruitment 2026',
    serviceDescription: 'RPSC Sub Inspector recruitment 2026 for Rajasthan Police. Selection through written examination and physical efficiency test. Applications accepted at CSC centres across the state.',
    qualifications: ['Graduation'],
    startDate: '2026-06-10',
    endDate: '2026-07-31',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '28',
    feeGeneral: '350',
    feeEWS: '250',
    feeOBC: '300',
    feeScSt: '200',
    cscCharge: 100,
    officialLink: 'https://rpsc.rajasthan.gov.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'EWS (Economically Weaker Section) Certificate',
    ],
    createdAt: '2026-06-01T10:00:00.000Z',
  },

  {
    id: 'svc-027',
    serviceCategory: 'UPSC CDS Recruitment',
    subCategory: 'Combined Defence Services Exam',
    state: 'All India',
    serviceName: 'UPSC CDS II Examination 2026',
    serviceDescription: 'UPSC Combined Defence Services Exam II 2026 for admission to Indian Military Academy, Officers Training Academy, Naval Academy, and Air Force Academy. Written test and SSB interview.',
    qualifications: ['12th Pass', 'Graduation'],
    startDate: '2026-06-04',
    endDate: '2026-07-10',
    admitCardDate: '2026-09-01',
    admitCardComingSoon: false,
    examDate: '2026-09-28',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '19',
    maxAge: '25',
    feeGeneral: '200',
    feeEWS: '0',
    feeOBC: '200',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://upsc.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Birth Certificate',
    ],
    createdAt: '2026-06-04T10:00:00.000Z',
  },

  {
    id: 'svc-028',
    serviceCategory: 'State Police Constable',
    subCategory: 'State Police Constable Bharti',
    state: 'Madhya Pradesh',
    serviceName: 'MP Police Constable GD Recruitment 2026',
    serviceDescription: 'Madhya Pradesh Police constable general duty posts. Selection through written test, physical efficiency test, and medical examination conducted by MPPRB.',
    qualifications: ['12th Pass'],
    startDate: '2026-06-15',
    endDate: '2026-07-25',
    admitCardDate: '2026-09-15',
    admitCardComingSoon: false,
    examDate: '2026-10-10',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '25',
    feeGeneral: '500',
    feeEWS: '250',
    feeOBC: '250',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://peb.mp.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – SC',
    ],
    createdAt: '2026-06-10T10:00:00.000Z',
  },

  {
    id: 'svc-029',
    serviceCategory: 'State Police Constable',
    subCategory: 'State Police Constable Bharti',
    state: 'Maharashtra',
    serviceName: 'Maharashtra Police Constable Bharti 2026',
    serviceDescription: 'Maharashtra Police constable recruitment for various posts across the state. Physical test, written examination, and medical screening by Maharashtra Police Recruitment Board.',
    qualifications: ['12th Pass'],
    startDate: '2026-06-15',
    endDate: '2026-07-31',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '28',
    feeGeneral: '500',
    feeEWS: '300',
    feeOBC: '400',
    feeScSt: '300',
    cscCharge: 100,
    officialLink: 'https://mahapolice.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-06-10T10:00:00.000Z',
  },

  {
    id: 'svc-030',
    serviceCategory: 'CRPF Constable Recruitment',
    subCategory: 'Central Reserve Police Force Bharti',
    state: 'All India',
    serviceName: 'CRPF Constable Technical and Tradesman 2026',
    serviceDescription: 'CRPF recruitment for Constable Technical and Tradesman posts. Physical standard test, written exam, skill/trade test, and medical examination. Apply through CSC before closing date.',
    qualifications: ['10th Pass', '12th Pass'],
    startDate: '2026-06-15',
    endDate: '2026-07-20',
    admitCardDate: '2026-09-05',
    admitCardComingSoon: false,
    examDate: '2026-10-01',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '23',
    feeGeneral: '200',
    feeEWS: '0',
    feeOBC: '200',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://crpf.gov.in',
    requiredDocuments: [
      '10th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-06-12T10:00:00.000Z',
  },

  {
    id: 'svc-031',
    serviceCategory: 'BSF Constable Recruitment',
    subCategory: 'Border Security Force Constable Bharti',
    state: 'All India',
    serviceName: 'BSF Constable GD and Tradesmen Recruitment 2026',
    serviceDescription: 'Border Security Force Constable General Duty and Tradesmen recruitment. Physical efficiency test, written examination, and medical. Candidates from border states given preference.',
    qualifications: ['10th Pass', '12th Pass'],
    startDate: '2026-06-20',
    endDate: '2026-07-25',
    admitCardDate: '2026-10-05',
    admitCardComingSoon: false,
    examDate: '2026-11-01',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '23',
    feeGeneral: '200',
    feeEWS: '0',
    feeOBC: '200',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://rectt.bsf.gov.in',
    requiredDocuments: [
      '10th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-06-14T10:00:00.000Z',
  },

  {
    id: 'svc-032',
    serviceCategory: 'State PSC Services',
    subCategory: 'State Public Service Commission Exam',
    state: 'Haryana',
    serviceName: 'HSSC Group D Recruitment 2026',
    serviceDescription: 'Haryana Staff Selection Commission Group D posts in various government departments for 2026. Minimum 8th pass qualification. Written test and document verification.',
    qualifications: ['8th Pass', '10th Pass'],
    startDate: '2026-06-15',
    endDate: '2026-07-20',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '17',
    maxAge: '42',
    feeGeneral: '150',
    feeEWS: '35',
    feeOBC: '35',
    feeScSt: '35',
    cscCharge: 80,
    officialLink: 'https://hssc.gov.in',
    requiredDocuments: [
      '8th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
    ],
    createdAt: '2026-06-12T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — AUGUST 2026 CLOSING ───────────────────────

  {
    id: 'svc-033',
    serviceCategory: 'IBPS PO Recruitment',
    subCategory: 'Bank Probationary Officer Exam',
    state: 'All India',
    serviceName: 'IBPS PO CRP XIV Recruitment 2026',
    serviceDescription: 'IBPS Probationary Officer exam for 19 public sector banks. Selection through preliminary exam, mains, group exercise, and interview. Key entry-level banking officer recruitment.',
    qualifications: ['Graduation'],
    startDate: '2026-07-01',
    endDate: '2026-08-15',
    admitCardDate: '2026-09-20',
    admitCardComingSoon: false,
    examDate: '2026-10-04',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '20',
    maxAge: '30',
    feeGeneral: '850',
    feeEWS: '175',
    feeOBC: '850',
    feeScSt: '175',
    cscCharge: 120,
    officialLink: 'https://ibps.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'EWS (Economically Weaker Section) Certificate',
    ],
    createdAt: '2026-06-25T10:00:00.000Z',
  },

  {
    id: 'svc-034',
    serviceCategory: 'Agniveer Army Recruitment',
    subCategory: 'Agniveer Army Bharti Application',
    state: 'All India',
    serviceName: 'Agniveer Army Bharti 2026',
    serviceDescription: 'Indian Army Agniveer recruitment under the Agnipath Scheme. Posts for General Duty, Technical, Clerk/Store Keeper, and Tradesman. Four-year service with partial corpus after tenure.',
    qualifications: ['10th Pass', '12th Pass'],
    startDate: '2026-07-01',
    endDate: '2026-08-20',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '17',
    maxAge: '21',
    feeGeneral: '250',
    feeEWS: '250',
    feeOBC: '250',
    feeScSt: '250',
    cscCharge: 80,
    officialLink: 'https://joinindianarmy.nic.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Birth Certificate',
    ],
    createdAt: '2026-06-25T10:00:00.000Z',
  },

  {
    id: 'svc-035',
    serviceCategory: 'Indian Navy Recruitment',
    subCategory: 'Navy Sailor and Officer Exam',
    state: 'All India',
    serviceName: 'Indian Navy Agniveer SSR Recruitment 2026',
    serviceDescription: 'Indian Navy Agniveer Senior Secondary Recruit under Agnipath Scheme. Posts for Sailors in various naval branches. Written test, fitness test, and medical selection.',
    qualifications: ['12th Pass'],
    startDate: '2026-07-05',
    endDate: '2026-08-31',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '17',
    maxAge: '21',
    feeGeneral: '300',
    feeEWS: '300',
    feeOBC: '300',
    feeScSt: '300',
    cscCharge: 80,
    officialLink: 'https://joinindiannavy.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Birth Certificate',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-06-28T10:00:00.000Z',
  },

  {
    id: 'svc-036',
    serviceCategory: 'KPSC Recruitment',
    subCategory: 'Karnataka Public Service Commission Exam',
    state: 'Karnataka',
    serviceName: 'Karnataka State Police SI Recruitment 2026',
    serviceDescription: 'Karnataka State Police Sub Inspector recruitment via KPSC. Selection through written examination, physical standard test, and interview. Apply before last date through CSC centres.',
    qualifications: ['Graduation'],
    startDate: '2026-07-01',
    endDate: '2026-08-10',
    admitCardDate: '2026-10-01',
    admitCardComingSoon: false,
    examDate: '2026-11-05',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '30',
    feeGeneral: '500',
    feeEWS: '250',
    feeOBC: '300',
    feeScSt: '200',
    cscCharge: 100,
    officialLink: 'https://ksp.karnataka.gov.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-06-28T10:00:00.000Z',
  },

  {
    id: 'svc-037',
    serviceCategory: 'BPSC Recruitment',
    subCategory: 'Bihar Public Service Commission Exam',
    state: 'Bihar',
    serviceName: 'BPSC 71st Combined Competitive Examination 2026',
    serviceDescription: 'Bihar Public Service Commission 71st CCE for Group B and C posts in Bihar government. Three-stage process: preliminary, mains, and interview. Apply online via CSC centres.',
    qualifications: ['Graduation'],
    startDate: '2026-07-10',
    endDate: '2026-08-31',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '20',
    maxAge: '37',
    feeGeneral: '600',
    feeEWS: '150',
    feeOBC: '600',
    feeScSt: '150',
    cscCharge: 100,
    officialLink: 'https://bpsc.bih.nic.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-07-01T10:00:00.000Z',
  },

  {
    id: 'svc-038',
    serviceCategory: 'JPSC Recruitment',
    subCategory: 'Jharkhand Public Service Commission Exam',
    state: 'Jharkhand',
    serviceName: 'Jharkhand Police Constable Bharti 2026',
    serviceDescription: 'Jharkhand Police constable recruitment for 2026. Written test, physical efficiency test, and medical examination. Domicile of Jharkhand required for non-reserved posts.',
    qualifications: ['12th Pass'],
    startDate: '2026-07-15',
    endDate: '2026-08-25',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '25',
    feeGeneral: '100',
    feeEWS: '50',
    feeOBC: '100',
    feeScSt: '50',
    cscCharge: 80,
    officialLink: 'https://jhpolice.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – ST',
    ],
    createdAt: '2026-07-05T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — SEPTEMBER 2026 CLOSING ────────────────────

  {
    id: 'svc-039',
    serviceCategory: 'SSC CGL Recruitment',
    subCategory: 'Combined Graduate Level Exam',
    state: 'All India',
    serviceName: 'SSC CGL 2026 Combined Graduate Level',
    serviceDescription: 'SSC CGL exam for Group B and C posts in central government ministries and departments. Includes posts like Inspector, Auditor, Accountant, and more. Tier I and Tier II online exams.',
    qualifications: ['Graduation'],
    startDate: '2026-08-01',
    endDate: '2026-09-15',
    admitCardDate: '2026-11-01',
    admitCardComingSoon: false,
    examDate: '2026-12-05',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '32',
    feeGeneral: '100',
    feeEWS: '0',
    feeOBC: '100',
    feeScSt: '0',
    cscCharge: 100,
    officialLink: 'https://ssc.nic.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'Caste Certificate – SC',
    ],
    createdAt: '2026-07-25T10:00:00.000Z',
  },

  {
    id: 'svc-040',
    serviceCategory: 'IBPS RRB PO Recruitment',
    subCategory: 'Regional Rural Bank Officer Scale Exam',
    state: 'All India',
    serviceName: 'IBPS RRB Officer Scale I Recruitment 2026',
    serviceDescription: 'IBPS Regional Rural Banks Officer Scale I recruitment. Selection through prelims, mains, and interview. Candidates placed in rural banks across India. Local language proficiency preferred.',
    qualifications: ['Graduation'],
    startDate: '2026-08-01',
    endDate: '2026-09-05',
    admitCardDate: '2026-10-10',
    admitCardComingSoon: false,
    examDate: '2026-11-02',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '30',
    feeGeneral: '850',
    feeEWS: '175',
    feeOBC: '850',
    feeScSt: '175',
    cscCharge: 110,
    officialLink: 'https://ibps.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-07-25T10:00:00.000Z',
  },

  {
    id: 'svc-041',
    serviceCategory: 'OPSC Recruitment',
    subCategory: 'Odisha Public Service Commission Exam',
    state: 'Odisha',
    serviceName: 'Odisha Police Constable Armed Recruitment 2026',
    serviceDescription: 'Odisha Police Armed Constable recruitment for various battalions. Physical measurement test, written exam, and medical examination. Domicile of Odisha required.',
    qualifications: ['12th Pass'],
    startDate: '2026-08-10',
    endDate: '2026-09-20',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '23',
    feeGeneral: '200',
    feeEWS: '100',
    feeOBC: '200',
    feeScSt: '100',
    cscCharge: 80,
    officialLink: 'https://odishapolice.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – SC',
    ],
    createdAt: '2026-07-28T10:00:00.000Z',
  },

  {
    id: 'svc-042',
    serviceCategory: 'TNPSC Recruitment',
    subCategory: 'Tamil Nadu Public Service Commission Exam',
    state: 'Tamil Nadu',
    serviceName: 'Tamil Nadu Police Sub Inspector Recruitment 2026',
    serviceDescription: 'Tamil Nadu Police SI recruitment by TNUSRB. Selection through written test, physical efficiency test, and endurance test. Domicile of Tamil Nadu required. Apply via CSC.',
    qualifications: ['Graduation'],
    startDate: '2026-08-15',
    endDate: '2026-09-30',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '20',
    maxAge: '28',
    feeGeneral: '300',
    feeEWS: '150',
    feeOBC: '250',
    feeScSt: '150',
    cscCharge: 90,
    officialLink: 'https://tnusrbonline.org',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-08-01T10:00:00.000Z',
  },

  {
    id: 'svc-043',
    serviceCategory: 'APSC Recruitment',
    subCategory: 'Assam Public Service Commission Exam',
    state: 'Assam',
    serviceName: 'Assam Police Constable Abhiyan Recruitment 2026',
    serviceDescription: 'Assam Police constable recruitment for districts across the state. Written exam, physical efficiency test, and medical. Candidates from tribal areas get additional relaxation.',
    qualifications: ['12th Pass'],
    startDate: '2026-08-10',
    endDate: '2026-09-15',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '26',
    feeGeneral: '100',
    feeEWS: '50',
    feeOBC: '100',
    feeScSt: '50',
    cscCharge: 80,
    officialLink: 'https://assampolice.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – ST',
    ],
    createdAt: '2026-08-01T10:00:00.000Z',
  },

  {
    id: 'svc-044',
    serviceCategory: 'UPSC NDA Recruitment',
    subCategory: 'National Defence Academy Exam',
    state: 'All India',
    serviceName: 'NDA and NA Examination II 2026',
    serviceDescription: 'UPSC NDA and Naval Academy Exam II for admission to Army, Navy, and Air Force wings. Two-stage selection: written test and SSB interview. Only male candidates eligible for NDA.',
    qualifications: ['12th Pass'],
    startDate: '2026-08-20',
    endDate: '2026-09-25',
    admitCardDate: '2026-11-15',
    admitCardComingSoon: false,
    examDate: '2026-12-14',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '16',
    maxAge: '19',
    feeGeneral: '100',
    feeEWS: '0',
    feeOBC: '100',
    feeScSt: '0',
    cscCharge: 80,
    officialLink: 'https://upsc.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Birth Certificate',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-08-15T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — OCTOBER 2026 CLOSING ──────────────────────

  {
    id: 'svc-045',
    serviceCategory: 'RBI Grade B Recruitment',
    subCategory: 'Reserve Bank of India Officer Exam',
    state: 'All India',
    serviceName: 'RBI Grade B Officer Direct Recruitment 2026',
    serviceDescription: 'RBI Grade B Officer recruitment for General, DEPR, and DSIM streams. Phase I online exam, Phase II, and interview. Highly competitive entry into the Reserve Bank of India.',
    qualifications: ['Graduation'],
    startDate: '2026-09-01',
    endDate: '2026-10-15',
    admitCardDate: '2026-11-20',
    admitCardComingSoon: false,
    examDate: '2026-12-10',
    examDateComingSoon: false,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '30',
    feeGeneral: '850',
    feeEWS: '100',
    feeOBC: '850',
    feeScSt: '100',
    cscCharge: 150,
    officialLink: 'https://rbi.org.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'EWS (Economically Weaker Section) Certificate',
    ],
    createdAt: '2026-08-25T10:00:00.000Z',
  },

  {
    id: 'svc-046',
    serviceCategory: 'Delhi Police Constable',
    subCategory: 'Delhi Police Head Constable Exam',
    state: 'Delhi',
    serviceName: 'Delhi Police Constable Bharti 2026',
    serviceDescription: 'Delhi Police constable recruitment for male and female candidates. Selection through computer-based examination, physical efficiency test, and medical. Special quota for Delhi domicile holders.',
    qualifications: ['12th Pass'],
    startDate: '2026-09-15',
    endDate: '2026-10-31',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '25',
    feeGeneral: '100',
    feeEWS: '0',
    feeOBC: '100',
    feeScSt: '0',
    cscCharge: 80,
    officialLink: 'https://delhipolice.gov.in',
    requiredDocuments: [
      '12th Pass Certificate / Marksheet (DMC)',
      'Aadhaar Card',
      'Domicile Certificate',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-09-01T10:00:00.000Z',
  },

  {
    id: 'svc-047',
    serviceCategory: 'GPSC Recruitment',
    subCategory: 'Gujarat Public Service Commission Exam',
    state: 'Gujarat',
    serviceName: 'Gujarat GPSC Class I-II Combined Exam 2026',
    serviceDescription: 'Gujarat PSC Class I and Class II Combined Competitive Exam for state government gazetted posts including Deputy Collector, DSP, and other senior posts. Prelims, mains, and interview.',
    qualifications: ['Graduation'],
    startDate: '2026-09-20',
    endDate: '2026-10-20',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '35',
    feeGeneral: '500',
    feeEWS: '250',
    feeOBC: '300',
    feeScSt: '250',
    cscCharge: 100,
    officialLink: 'https://gpsc.gujarat.gov.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
      'Caste Certificate – OBC (Central List)',
    ],
    createdAt: '2026-09-10T10:00:00.000Z',
  },

  // ── RECRUITMENT & EXAM SERVICES — NOVEMBER 2026 CLOSING ─────────────────────

  {
    id: 'svc-048',
    serviceCategory: 'LIC AAO Recruitment',
    subCategory: 'LIC Assistant Administrative Officer Exam',
    state: 'All India',
    serviceName: 'LIC AAO Assistant Administrative Officer 2026',
    serviceDescription: 'LIC AAO recruitment for Generalist, IT, CA, Actuarial, and Rajbhasha streams. Selection through prelims, mains, and interview. Attractive pay scale and career growth in India\'s largest insurer.',
    qualifications: ['Graduation'],
    startDate: '2026-10-01',
    endDate: '2026-11-15',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '30',
    feeGeneral: '700',
    feeEWS: '0',
    feeOBC: '700',
    feeScSt: '0',
    cscCharge: 120,
    officialLink: 'https://licindia.in/home/careers',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
    ],
    createdAt: '2026-09-20T10:00:00.000Z',
  },

  {
    id: 'svc-049',
    serviceCategory: 'SBI PO Recruitment',
    subCategory: 'State Bank of India PO Exam',
    state: 'All India',
    serviceName: 'SBI PO Probationary Officer Recruitment 2026',
    serviceDescription: 'SBI Probationary Officer recruitment. Selection through preliminary exam, mains, group exercise, and personal interview. India\'s largest bank offers structured career path for POs.',
    qualifications: ['Graduation'],
    startDate: '2026-10-15',
    endDate: '2026-11-30',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '21',
    maxAge: '30',
    feeGeneral: '750',
    feeEWS: '0',
    feeOBC: '750',
    feeScSt: '0',
    cscCharge: 120,
    officialLink: 'https://sbi.co.in/careers',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Passport Size Photographs (Colour, White Background)',
      'EWS (Economically Weaker Section) Certificate',
    ],
    createdAt: '2026-09-25T10:00:00.000Z',
  },

  {
    id: 'svc-050',
    serviceCategory: 'KERALAPSC Recruitment',
    subCategory: 'Kerala Public Service Commission Exam',
    state: 'Kerala',
    serviceName: 'Kerala PSC Combined Civil Services Prelims 2026',
    serviceDescription: 'Kerala Public Service Commission Combined Civil Services preliminary examination for various Group I posts including Deputy Collector, DSP, and senior state service positions.',
    qualifications: ['Graduation'],
    startDate: '2026-10-20',
    endDate: '2026-11-20',
    admitCardDate: '',
    admitCardComingSoon: true,
    examDate: '',
    examDateComingSoon: true,
    serviceImage: null,
    serviceImagePreview: null,
    minAge: '18',
    maxAge: '41',
    feeGeneral: '300',
    feeEWS: '150',
    feeOBC: '200',
    feeScSt: '150',
    cscCharge: 100,
    officialLink: 'https://keralapsc.gov.in',
    requiredDocuments: [
      'B.A. Degree & Marksheet',
      'Aadhaar Card',
      'Domicile Certificate',
    ],
    createdAt: '2026-10-01T10:00:00.000Z',
  },

];

export default MOCK_SERVICES;
